module.exports = __webpack_public_path__ + "static/screen-orari-dark-c9a1b188d7d280f4c4a37139ff185552.png";